/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ModelPurchaseAggBySku } from 'account-client'
import { useCloudRegion } from '@/hooks/useCloudRegion'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { useTranslateEnum } from '@/hooks/useTranslateEnum'
import { CloudLabelWithIcon } from '@/pages/cloud/features/CloudLabelWithIcon'
import { CloudProvider } from '@/pages/cloud/interface'

export function useProductPurchasesColumns() {
  const { t } = useTranslation()
  const { currency } = useTranslateAmount()
  const { translate } = useTranslateEnum()
  const { getRegionName } = useCloudRegion()

  const columns = useMemo<TableColumnsType<ModelPurchaseAggBySku>>(
    () => [
      {
        title: t('Product'),
        dataIndex: 'product',
        // width: 100,
        // fixed: 'left',
        render: value => translate(value),
      },
      {
        title: t('Type'),
        dataIndex: 'type',
        // width: 100,
        // fixed: 'left',
        render: value => translate(value),
      },
      {
        title: t('SubType'),
        dataIndex: 'subType',
        // width: 100,
        render: value => translate(value),
      },
      {
        title: t('Edition'),
        dataIndex: 'edition',
        // width: 100,
        render: value => translate(value),
      },
      {
        title: t('Cloud Provider'),
        dataIndex: 'cloudProvider',
        render: value => <CloudLabelWithIcon cloud={value} />,
      },
      {
        title: t('Region'),
        dataIndex: 'region',
        render: (value, record) => getRegionName(record.cloudProvider as CloudProvider, value),
      },
      {
        title: t('Consumption'),
        dataIndex: 'consumptionFormatted',
        // width: 200,
      },
      {
        title: t('Consumption Unit'),
        dataIndex: 'consumptionUnit',
        // width: 200,
      },
      // {
      //   title: t('Unit Price'),
      //   dataIndex: 'listPriceFormatted',
      //   // width: 190,
      // },
      // {
      //   title: t('Price Unit'),
      //   dataIndex: 'priceUnit',
      //   // width: 190,
      // },
      // {
      //   title: t('Zhe Kou'),
      //   dataIndex: 'zhekouFormatted',
      //   // width: 80,
      // },
      {
        title: `${t('Total Amount')}（${currency}）`,
        dataIndex: 'amountFormatted',
        // width: 150,
        // defaultSortOrder: 'descend',
        sorter: (a, b) => Number(a.amount) - Number(b.amount),
      },
    ],
    [],
  )

  return columns
}
